import { getImageSourceUrl } from './utils'
import '@vant/touch-emulator';

/**
 * 引入Vant至项目中使用
 */
// 1. 引入你需要的组件
import { Lazyload, Locale } from 'vant'

// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
Locale.use('en-US', enUS);

export default defineNuxtPlugin((NuxtApp) => {
  if(process.client) {
    window.addEventListener('error', (el: ErrorEvent) => {
      if(el.target && el.target instanceof HTMLImageElement) {
        const _src = el.target.src

        if(_src && _src.indexOf('.webp') > -1 || /format,webp/.test(_src)) {
          el.target.src = getImageSourceUrl(_src)
        }
      }
    }, true)
  }

  NuxtApp.vueApp
  .use(Lazyload, {
    lazyComponent: true,
    attempt: 2,
    error: useImg1pxBase64().value,
    loading: useImg1pxBase64().value,
    adapter: {
      error (listender: any) {
        if(listender.el.tagName === 'IMG') {
          const _src = listender.src

          if(_src && _src.indexOf('.webp') > -1 || /format,webp/.test(_src)) {
            listender.el.src = getImageSourceUrl(_src)
          }
        }
      }
    }
  })
})